<template>
  <div>
    <!-- 新增、删除按钮及搜索框 -->
    <el-row type="flex" justify="space-between" align="middle" class="tool-tips">
      <el-col>
        <el-button type="primary" @click="handleAdd">新增</el-button>
        <el-button type="danger" @click="handleDeleteBatch">批量删除</el-button>
      </el-col>
      <el-col align="right">
        <el-input
          v-model="searchValue"
          placeholder="请输入搜索内容"
          class="input-with-select"
          @keyup.enter.native="handleSearch"
        >
          <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
        </el-input>
      </el-col>
    </el-row>
    <!-- 表格 -->
    <el-table :data="tableData" tooltip-effect="dark" @selection-change="handleSelectionChange">
      <el-table-column type="selection" align="center"></el-table-column>
      <!-- 当内容过长被隐藏时显示 tooltip -->
      <el-table-column width="200px" label="内容" align="center" prop="info_lang" show-overflow-tooltip>
        <template slot-scope="scope">
          <div class="content">
          
             {{ scope.row.content_lang }}
             
          </div>
       
        </template>
      </el-table-column>
    
      <el-table-column prop="updatetime_str" align="center" label="最后修改时间"></el-table-column>
      <el-table-column prop="starttime_str" align="center" label="开始时间"></el-table-column>
      <el-table-column prop="endtime_str" align="center" label="结束时间"></el-table-column>
      <!-- <el-table-column prop="update_time_str" align="center" label="最后修改时间"></el-table-column> -->
      <el-table-column width="100px" label="启用开关" align="center" prop="state_bool">
        <template #default="{row}">
          <el-switch
            v-model="row.switch"
            active-color="#13ce66"
            inactive-color="#A3A3A3"
            :active-value="1" 
            :inactive-value="2" 
            :key="row.id"
            @change="switch_change(row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          
          <el-button type="primary" @click="handleEdit(scope.row)" icon="el-icon-edit" circle></el-button>
          <el-button type="danger" @click="handleDelete(scope.row)" icon="el-icon-delete" circle></el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增/编辑公告弹窗 -->
<el-dialog 
    :title="dialogTitle" 
    :visible.sync="dialogVisible" 
    width="60%"
    :before-close="handleClose">
    <el-form :model="formData" label-width="100px">
      <el-form-item label="公告内容">
         <name-lang :edit_lan="formData.content" @lang_change="content_lang_change"></name-lang>
      </el-form-item>
      <el-form-item label="开始时间">
       <el-date-picker
          v-model="pickedtime"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="timepickerOptions"
          @change="notice_time_change">
          </el-date-picker>
      </el-form-item>
      <el-form-item label="启用开关">
        <el-switch
          v-model="formData.switch"
          :active-value="1"
          :inactive-value="2"
          active-color="#13ce66"
          inactive-color="#A3A3A3">
        </el-switch>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </div>
  </el-dialog>

    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[2, 4, 8, 16]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalcount"
      class="pagination"
    ></el-pagination>
  </div>
</template>

<script>
import NameLang from "../components/Lang/NameLang.vue";
import { notice_edit,notice_list,notice_del,notices_del } from '../api/api';
import { getYMDHMS } from '../utils';
import { SystemStore } from "../store";
export default {
  components:{
    NameLang
  },
  data() {
    return {
      timepickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      pickedtime:[],
      formData:{},
      dialogTitle:'',
      dialogVisible:false,
      state:true,
      // 表格数据
      tableData: [],
      // 批量删除商品的id
      ids: [],
     
      // 搜索框的值
      searchValue: "",
      // 分页器当前页
      currentPage: SystemStore().getCurrentPage,
      // 每页的商品数
      pageSize: 8,
      // 总商品数
      totalcount: 0,

      props: {
        checkStrictly: true, // 允许父节点单独选中
      }
    };
  },

  methods: {
    notice_time_change(){
      this.formData.start_timestamp = this.pickedtime[0].getTime()
      this.formData.end_timestamp = this.pickedtime[1].getTime()
    },
    content_lang_change(json_lans){
      this.formData.content = JSON.stringify(json_lans);
    },
    handleClose(){
      this.dialogVisible = false
    },

    async handleSubmit(){

    try {
       await notice_edit(this.formData)

       this.$message.success('保存成功')

       this.dialogVisible = false;

       this.getNoticeList()
    } catch (error) {
      this.$message.error(error.message)
    }
     


    },


    // 点击新增
    handleAdd() {
      // 跳转新增页面
      this.formData = {}
      this.dialogVisible = true
    },
   
    // 批量删除
    handleDeleteBatch() {
      // 将所有id变成以","分隔的字符串 如1,2,3
      const ids = this.ids.join(",");
      // 如果字符串为空，以为这还没选择任一商品
      if (!ids) {
        // 弹框提示
        this.$message({
          type: "warning",
          message: "您还没选择任何公告呢"
        });
        return;
      }
      // 弹窗确认框
      this.$confirm("是否删除所选公告?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // 确定则发送删除请求
          //   获取id
          notices_del(ids)
          .then(res=>{
            this.$message({
              type: "success",
              showClose: true,
              message: `删除成功`,
            });
             // 重新获取数据
             this.getNoticeList();
          })
          .catch(err=>{
            this.$message({
              showClose: true,
              message: err,
              type:"error"
            })
          })
        })
        .catch(() => {
          // 取消的时候什么都不做
        });
    },
    // 搜索
    handleSearch() {
      // 根据搜索值获取商品
      this.getNoticeList();
    },
    handleSelectionChange(val) {
      // val为选择的行
      var ids = val.map(v => v.id);
      this.ids = ids;
    },
    // 编辑商品
    handleEdit(val) {
      // 点击编辑获取商品的id
      this.formData = val

      // 转换为 pickedtime 格式（Date 对象数组）
    this.pickedtime = [
       this.formData.start_timestamp?new Date(this.formData.start_timestamp):0, // 第一个元素：开始时间 Date
       this.formData.end_timestamp? new Date(this.formData.end_timestamp):0   // 第二个元素：结束时间 Date
    ];
      // 跳转到编辑页面
      // this.$router.push(`./GoodsEdit/${id}`);

      this.dialogVisible = true
    },

    // 删除单行数据
    handleDelete(val) {
      // 弹窗确认框
      this.$confirm(`是否删除${val.content_lang}?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // 确定则发送删除请求
          //   获取id
          const { id } = val;
          notice_del(id)
          .then(res=>{
            this.$message({
              type: "success",
              showClose: true,
              message: `删除成功`,
            });
             // 重新获取数据
             this.getNoticeList();
          })
          .catch(err=>{
            this.$message({
              showClose: true,
              message: err,
              type:"error"
            })
          })
        
        })
        .catch(() => {
          // 取消的时候什么都不做
        });
    },
    // 每页条数改变的时候
    handleSizeChange(val) {
      // 重新改变每页条数
      this.pageSize = val;
      // 并重新获取数据
      this.getNoticeList();
    },
    // 当前页改变的时候
    handleCurrentChange(val) {
      // 修改当前页
      this.currentPage = val;
      // 并重新获取数据
      this.getNoticeList();

      SystemStore().update_current_page(this.currentPage)

      localStorage.setItem('goodlistpage', this.currentPage)
    },
    // 获取商品
    getNoticeList() {
      // 发起获取商品请求
      notice_list()
      .then(res=>{
        console.log('list',res)
        this.tableData = res.list
        this.totalcount = res.total;
        this.timeformat(this.tableData)
        // this.totalcount = res.data.totalcount;
      })
    },
    timeformat(list){
      list.forEach(notice => {
        notice.updatetime_str = notice.update_time// getYMDHMS(notice.update_time)
        notice.starttime_str = getYMDHMS(notice.start_timestamp)
        notice.endtime_str = getYMDHMS(notice.end_timestamp)
        notice.content_lang = JSON.parse(notice.content)['1']
      });
    },
    switch_change(e){
      
      notice_edit(e)
      .catch(err=>{
        e.switch = e.switch?0:1
        this.$message({
          showClose: true,
          message: err,
          type:"error"
        })
      })
    }
  },
  mounted() {
    //   页面加载成功后获取商品列表
    this.getNoticeList();
   
  }
};
</script>

<style lang="less" scoped>
.tool-tips {
  margin: 20px 0;

  .input-with-select {
    width: 50%;
  }
}
.el-select .el-input {
  width: 130px;
}

.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.cover-name{
  height: 100%;
}
.good-img {
  width: 60px;
  padding: 0 10px;
}

.good-name{
  font-weight: bold;
  font-size: 16px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* 限制行数为2 */
  overflow: hidden;
  text-overflow: ellipsis;
}

.good-id{
  font-size: 12px;
  color:rgb(135, 140, 151);
  text-align: left;
}

.pagination {
  margin-top: 20px;
}
</style>